<template>
  <div>
    <div class="card px-2 py-3 mb-3 shadow-sm d-flex">
      <div class="d-flex my-0">
        <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-sm"
              >Period</span
            >
          </div>
          <date-picker
            class="form-control"
            v-model="filterYearMonth"
            :config="datePickerConfig"
            placeholder="Start Date"
            :disabled="!allLoading"
          />
        </div>
        <span v-if="!allLoading" class="loadingres mx-2 mt-2 spinner-border loading-spinner text-primary">
        </span>

        <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper" v-if="filterYearMonth">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-sm"
              >Account</span
            >
          </div>
          <select
            class="form-control"
            v-model="typeSelected"
            @change="selectMonth"
            :disabled="!allLoading"
          >
          <option value="0">Select option</option>
          <option value="2" >Manager</option>
          <option value="3">Executive</option>
          </select>
        </div>
        <div
          class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
          v-if="!oliverSalesLoaded && userOliverSales.length > 1 && typeSelected == '2'"
        >
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-sm">Manager</span>
          </div>
          <IndustrySearch
            :option_list="userOliverSales"
            :default_values="userOliverSale"
            :key="3"
            :multiple="false"
            @selected="selectOliverSale"
            :isDisabled="!allLoading"
            class="form-control inline-table"
          />
        </div>

        <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper" v-if="!oliverExecutiveLoaded && userAccountExecutives.length > 1 && typeSelected == '3'">
          <div class="input-group-prepend">
            <span class="input-group-text" id="inputGroup-sizing-sm">Executive</span>
          </div>
          <IndustrySearch
          :option_list="userAccountExecutives"
          :default_values="userOliverExecutive"
          :key="4"
          :multiple="false"
          @selected="selectOliverExecutive"
          :isDisabled="!allLoading"
          class="form-control inline-table"
          />
        </div>
        <span v-if="!allLoading" class="loadingres mx-2 mt-2 spinner-border loading-spinner text-primary">
        </span>

      </div>

      <div>

      </div>
      <div
        v-if="(loadingDataSale && userOliverSale[0] != '0') && (loadingDataExecutive && userOliverExecutive[0] != '0')"
        class="d-flex col-12 col-md-12 justify-content-end py-0 my-0"
      >
        <span class="loadingres spinner-border loading-spinner text-primary">
        </span>
      </div>
      <div
        class="d-flex col-12 col-md-12 justify-content-end py-0 my-0"
        v-if="!loadingDataSale && userOliverSale[0] != '0'"
      >
        <span class="mx-0 p-0" v-if="saleRankingData.total">
          <img
            class="ml-1"
            :src="logoRevenueRanking(saleRankingData.total)"
            height="78px"
        /></span>
        <span class="mx-0" v-if="saleRankingData.avatar">
          <img
            class="ml-1 rounded-circle shadow"
            :src="saleRankingData.avatar"
            height="70px"
          />
        </span>
        <span class="mx-0" v-else>
          <img
            class="ml-1 rounded-circle shadow"
            :src="require('@/assets/images/emptyperson.png')"
            height="70px"
          />
        </span>
      </div>

      <div
        class="d-flex flex-row justify-content-center py-0 my-0 w-100 pt-4"
        v-if="typeSelected == '0' ||
        (typeSelected == '2' && userOliverSale[0] == '0') ||
        (typeSelected == '3' && userOliverExecutive[0] == '0')"
      >
        <div class="col-lg-12 pt-2 text-center py-0">
          <img
            src="@/assets/images/search-oliver3.png"
            class="rounded mx-auto d-block py-0"
            width="180px"
          />
        </div>
      </div>

      <!-- Clients -->
      <div class="col-12 mt-4">
        <div class="row" v-if="clients.length > 0">
          <div class="col-12 text-center ">
            <div class="row d-flex justify-content-center">
              <div class="col" v-for="client in clients" :key="client.id">
                <!-- Muestro componente de cargando. -->
                <div class="card" v-if="gettingDataClient">
                  <Loadingcircle :paramloading="paramloading" />
                </div>

                <template v-else>
                  <div
                    class="card text-center py-2"
                    v-if="client.data.length > 0"
                  >
                    <Tooltip :text="client.textoToTooltip" :width="''">
                      <p
                        class="cursor-pointer"
                        @click="
                          OpenModal(
                            client.detail,
                            client.label,
                            client.description
                          )
                        "
                      >
                        {{ client.label }}
                        <i class="ml-1 icon-eye"></i>
                      </p>
                    </Tooltip>

                    <p
                      class="cursor-pointer"
                      :class="compareTotals(client)"
                      @click="
                        OpenModal(
                          client.detail,
                          client.label,
                          client.description
                        )
                      "
                    >
                      <span class="h2">
                        {{ getTotal("currentMonth", client) }}
                      </span>
                      <span class="ml-2 h4">
                        <i :class="compareTotals(client, 'arrow')"></i>
                      </span>
                    </p>

                    <small>
                      {{ getDate("beforeMonth", client) }}
                      {{ getTotal("beforeMonth", client) }}</small
                    >
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Clients AVG-->
      <div class="col-12 mt-4">
        <div class="row" v-if="clients_avg.length > 0">
          <div class="col-12 text-center ">
            <div class="row d-flex justify-content-center">
              <div class="col" v-for="client in clients_avg" :key="client.id">
                <!-- Muestro componente de cargando. -->
                <div
                  class="card"
                  v-if="isClientAvgMetricLoading(client)"
                >
                  <Loadingcircle :paramloading="paramloading" />
                </div>

                <template v-else>
                  <div
                    class="card text-center py-2"
                    v-if="client.data.length > 0 || isAlwaysVisibleClientAvgMetric(client)"
                  >
                    <Tooltip :text="client.textoToTooltip" :width="''">
                      <p
                        class="cursor-pointer"
                        @click="
                          OpenModal(
                            client.detail,
                            client.label,
                            client.description
                          )
                        "
                      >
                        {{ client.label }}
                        <i class="ml-1 icon-eye"></i>
                      </p>
                    </Tooltip>

                    <p
                      class="cursor-pointer"
                      :class="compareTotals(client)"
                      @click="
                        OpenModal(
                          client.detail,
                          client.label,
                          client.description
                        )
                      "
                    >
                      <span class="h2">
                        {{ getTotal("currentMonth", client) }}
                      </span>
                      <span class="ml-2 h4">
                        <i :class="compareTotals(client, 'arrow')"></i>
                      </span>
                    </p>

                    <small>
                      {{ getDate("beforeMonth", client) }}
                      {{ getTotal("beforeMonth", client) }}</small
                    >
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- Order Performances -->
      <div class="col-12 mt-3 ">
        <div class="row" v-if="performances.length > 0">
          <div class="col-12 text-center ">
            <div class="row d-flex justify-content-center">
              <div
                class="col"
                v-for="performance in performances"
                :key="performance.id"
              >
                <!-- Muestro componente de cargando. -->
                <div class="card" v-if="gettingDataPerformance">
                  <Loadingcircle :paramloading="paramloading" />
                </div>

                <template v-else>
                  <div
                    class="card text-center py-2"
                    v-if="performance.data.length > 0"
                  >
                    <Tooltip :text="performance.textoToTooltip" :width="''">
                      <p>{{ performance.label }}</p>
                    </Tooltip>
                    <p :class="compareTotals(performance)">
                      <span class="h3">
                        {{ getTotal("currentMonth", performance) }}
                      </span>
                      <span class="ml-2 h4">
                        <i :class="compareTotals(performance, 'arrow')"></i>
                      </span>
                    </p>

                    <small>
                      {{ getDate("beforeMonth", performance) }}
                      {{ getTotal("beforeMonth", performance) }}</small
                    >
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sales -->
      <div class="col-12 mt-3">
        <div class="row" v-if="sales.length > 0">
          <div class="col-12">
            <div class="row">
              <div class="col" v-for="sale in sales" :key="sale.id">
                <!-- Muestro componente de cargando. -->
                <div class="card" v-if="gettingDataSale">
                  <Loadingcircle :paramloading="paramloading" />
                </div>

                <template v-else>
                  <div
                    class="card text-center py-2"
                    v-if="sale.data.length > 0"
                  >
                    <Tooltip :text="sale.textoToTooltip" :width="''">
                      <p
                        class="cursor-pointer"
                        @click="
                          OpenModal(sale.detail, sale.label, sale.description)
                        "
                      >
                        {{ sale.label }}
                        <i v-if="sale.description" class="ml-1 icon-eye"></i>
                      </p>
                    </Tooltip>
                    <p
                      class="cursor-pointer"
                      :class="compareTotals(sale)"
                      @click="
                        OpenModal(sale.detail, sale.label, sale.description)
                      "
                    >
                      <span class="h3">
                        {{ getTotal("currentMonth", sale) }}
                      </span>
                      <span class="ml-2 h4">
                        <i :class="compareTotals(sale, 'arrow')"></i>
                      </span>
                    </p>

                    <small>
                      {{ getDate("beforeMonth", sale) }}
                      {{ getTotal("beforeMonth", sale) }}</small
                    >
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Problems -->
       <!--
      <div class="col-12 mt-3">
        <div class="row" v-if="problems.length > 0">
          <div class="col-12">
            <div class="row">
              <div class="col-3" v-for="problem in problems" :key="problem.id">
                <div class="card" v-if="gettingDataProblem">
                  <Loadingcircle :paramloading="paramloading" />
                </div>

                <template v-else>
                  <div
                    class="card text-center py-2"
                    v-if="problem.data.length > 0"
                  >
                    <Tooltip :text="problem.textoToTooltip" :width="''">
                      <p>{{ problem.label }}</p>
                    </Tooltip>
                    <p :class="compareTotals(problem)">
                      <span class="h3">
                        {{ getTotal("currentMonth", problem) }} h
                      </span>
                      <span class="ml-2 h4">
                        <i :class="compareTotals(problem, 'arrow')"></i>
                      </span>
                    </p>

                    <small>
                      {{ getDate("beforeMonth", problem) }}
                      {{ getTotal("beforeMonth", problem) }}
                      <span v-if="getTotal('beforeMonth', problem)"
                        >h</span
                      ></small
                    >
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
     -->

      <!-- Meetings -->
      <div class="col-12 mt-3">
        <div class="row" v-if="meeting.length > 0">
          <div class="col-12">
            <div class="row">
              <div class="col-3" v-for="meet in meeting" :key="meet.id">
                <!-- Muestro componente de cargando -->
                <div class="card" v-if="gettingDataMeeting">
                  <Loadingcircle :paramloading="paramloading" />
                </div>

                <template v-else>
                  <div
                    class="card text-center py-2"
                    v-if="meet.data.length > 0"
                  >
                    <Tooltip :text="meet.textoToTooltip" :width="''">
                      <p>{{ meet.label }}</p>
                    </Tooltip>
                    <p :class="compareTotals(meet)">
                      <span class="h3">
                        {{ getTotal("currentMonth", meet) }}
                      </span>
                      <span class="ml-2 h4">
                        <i :class="compareTotals(meet, 'arrow')"></i>
                      </span>
                    </p>

                    <small>
                      {{ getDate("beforeMonth", meet) }}
                      {{ getTotal("beforeMonth", meet) }}
                    </small>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Calls -->
      <div class="col-12 mt-3">
        <div class="row" v-if="calls.length > 0">
          <div class="col-12">
            <div class="row">
              <div class="col-3" v-for="call in calls" :key="call.id">
                <!-- Muestro componente de cargando -->
                <div class="card" v-if="gettingDataCalls">
                  <Loadingcircle :paramloading="paramloading" />
                </div>

                <template v-else>
                  <div
                    class="card text-center py-2"
                    v-if="call.data.length > 0"
                  >
                    <Tooltip :text="call.textoToTooltip" :width="''">
                      <p>{{ call.label }}</p>
                    </Tooltip>
                    <p :class="compareTotals(call)">
                      <span class="h3">
                        {{ getTotal("currentMonth", call) }}
                      </span>
                      <span class="ml-2 h4">
                        <i :class="compareTotals(call, 'arrow')"></i>
                      </span>
                    </p>

                    <small>
                      {{ getDate("beforeMonth", call) }}
                      {{ getTotal("beforeMonth", call) }}
                    </small>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div
      class="card px-2 py-3 shadow-sm my-4"
      v-if="
        (userOliverSale[0] != '0' ||
        userOliverExecutive[0] != '0') &&
        filterYearMonth &&
        gettingDataClient == false
      "
    >
      <div class="col-12">
        <OrderPerformanceToSaleDashboard
          :tabId="'20'"
          :condition="'LowOperatingMargin'"
          :oliver_sale_id="userOliverSale[0]"
          :account_executive ="userOliverExecutive[0]"
          :yearMonth="filterYearMonth"
          :showTotals="true"
        />
      </div>
    </div>

    <!-- Modal show table -->
    <Modal name="list" v-if="itemDetail" :size="'60'" :max-width="'650'">
      <ListDataSaleMetrics
        :item="itemDetail"
        :itemLabel="itemLabel"
        :itemDescription="itemDescription"
        :userOliverSale="userOliverSale[0] == 0 ? userOliverExecutive[0] : userOliverSale[0]"
        :month="filterYearMonth"
        :userType="userOliverSale[0] == 0 ? 'account_executive' : 'sale_oliver'"
      />
    </Modal>
  </div>
</template>

<script>
import moment from "moment";
import { usersService, clientsService } from "@/_services";
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import Loadingcircle from "@/components/Common/Loadingcircle.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import OrderPerformanceToSaleDashboard from "@/components/Performances/OrderPerformanceToSaleDashboard.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import Modal from "@/components/Common/Modal.vue";
import ListDataSaleMetrics from "@/components/Performances/ListDataSaleMetrics.vue";
import { mapState } from "vuex";

export default {
  name: "MontlyMetrics",
  components: {
    IndustrySearch,
    Loadingcircle,
    LoadingSpinner,
    OrderPerformanceToSaleDashboard,
    Tooltip,
    Modal,
    ListDataSaleMetrics,
  },
  data() {
    return {
      previousValue: null,
      filterYearMonth: null, // moment().format("YYYY-MM"),
      datePickerConfig: {
        format: "YYYY-MM",
        // useCurrent: false,
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day"),
      },
      revenue_ranking: [
        {
          id: 1,
          img: "1_novice_closer.png",
          label: "Novice Closer",
          min: 0,
          max: 15000,
        },
        {
          id: 2,
          img: "2_deal_maker.png",
          label: "Deal Maker",
          min: 15001,
          max: 40000,
        },
        {
          id: 3,
          img: "3_sales_navigator.png",
          label: "Sales Navigator",
          min: 40001,
          max: 80000,
        },
        {
          id: 4,
          img: "4_revenue_builder.png",
          label: "Revenue Builder",
          min: 80001,
          max: 150000,
        },
        {
          id: 5,
          img: "5_growth_catalyst.png",
          label: "Growth Catalyst",
          min: 150001,
          max: 250000,
        },
        {
          id: 6,
          img: "6_campaign_master.png",
          label: "Campaign Master",
          min: 250001,
          max: 400000,
        },
        {
          id: 7,
          img: "7_lead_strategist.png",
          label: "Lead Strategist",
          min: 400001,
          max: 600000,
        },
        {
          id: 8,
          img: "8_deal_architech.png",
          label: "Deal Architect",
          min: 600001,
          max: 900000,
        },
        {
          id: 9,
          img: "9_revenue_guru.png",
          label: "Revenue Guru",
          min: 900001,
          max: 1200000,
        },
        {
          id: 10,
          img: "10_b2b_rainmaker.png",
          label: "B2B Rainmaker",
          min: 1200001,
          max: 5200000,
        },
      ],
      saleRankingData: null,
      loadingDataSale: true,
      loadingDataExecutive: true,
      typeSelected: "0",
      itemLabel: false,
      itemDetail: false,
      itemDescription: false,
      gettingDataSale: false,
      gettingDataProblem: false,
      gettingDataPerformance: false,
      gettingDataClient: false,
      gettingDataMeeting: false,
      gettingDataCalls: false,
      gettingDataClientAvg: false,
      gettingDataAverageMargin: false,
      gettingDataAverageRevenue: false,
      sales: [
        {
          id: "new_clients",
          detail: "new_clients",
          label: "New clients",
          data: [],
          textoToTooltip: "New clients signed.",
          description:
            "Customers who have registered a first payment method in the selected month.",
        },
        {
          id: "paid_leads",
          label: "Paid invoices",
          data: [],
          textoToTooltip: "Total Paid invoices generated excluding tax.",
        },
        {
          id: "new_orders",
          detail: "new_orders",
          label: "New campaign (new client)",
          data: [],
          textoToTooltip:
            "Total number of new campaigns sold to customers who have already had active campaigns on Oliverlist in the past.",
          description:
            "Campaigns that have gone to 'Preparing' status in the selected month and that the copywriting has been validated by Oliverlist. Apply for customers who have registered the first payment method in the selected month.",
        },
        {
          id: "total_orders",
          detail: "new_orders_old_client",
          label: "New campaigns (old clients)",
          data: [],
          textoToTooltip: "Total number of new campaigns sold to new customers.",
          description:
            "Campaigns that have gone to 'Preparing' status in the selected month and that the copywriting has been validated by Oliverlist. Apply for customers who have registered the first payment method in a previous month.",
        },
        {
          id: "avg_meeting_price",
          detail: "avg_meeting_price",
          label: "AVG meeting price",
          data: [],
          textoToTooltip: "Average price excluding tax of campaigns sold.",
        },
        {
          id: "declined_recovery_paid",
          detail: "declined_recovery_paid",
          label: "Declined/Recovery Amount",
          data: [],
          textoToTooltip:
            "Sum of funds under 'Payment Declined' or 'Recovery' status.",
          description:
            "Sum of funds under 'Payment Declined' or 'Recovery' status.",
        },
      ],
      // problems: [
      //   {
      //     id: "avg_lcm",
      //     label: "AVG LCM",
      //     data: [],
      //     textoToTooltip:
      //       "Average time to resolve an order that appears in the Low Cashable Margin list in the Performance view.",
      //   },
      //   {
      //     id: "avg_lom",
      //     label: "AVG LOM",
      //     data: [],
      //     textoToTooltip:
      //       "Average time to resolve an order that appears in the Low Operating Margin list in the Performance view.",
      //   },
      //   {
      //     id: "avg_com",
      //     label: "AVG COM",
      //     data: [],
      //     textoToTooltip:
      //       "Average time to resolve an order that appears in the Critical Cashable Margin list in the Performance view.",
      //   },
      //   {
      //     id: "avg_wac",
      //     label: "AVG WAC",
      //     data: [],
      //     textoToTooltip:
      //       "Average time to resolve an order that appears in the Warning Available Contacts list in the Performance view.",
      //   },
      // ],
      performances: [
        {
          id: "revenue",
          label: "Revenue",
          data: [],
          textoToTooltip: "Total revenue generated excluding tax.",
        },
        {
          id: "revenue_subscriptions",
          label: "Subscriptions",
          data: [],
          textoToTooltip: "Total subscriptions revenue generated excluding tax.",
        },
        {
          id: "revenue_orders",
          label: "Revenue / Campaigns",
          data: [],
          textoToTooltip: "Total revenue generated excluding tax per campaign.",
        },
        {
          id: "meetings_orders",
          label: " Meetings / campaigns",
          data: [],
          textoToTooltip: "Average number of appointments generated per campaign.",
        },
        {
          id: "conversion_rate",
          label: "Meetings / unique prospects (month)",
          data: [],
          textoToTooltip:
            "Total number of appointments generated out of the total number of new contacts involved in campaigns.",
        },
      ],
      clients: [
        {
          id: "total_client_active",
          detail: "active_clients",
          label: "Active clients",
          data: [],
          textoToTooltip:
            "Total number of customers whose campaigns have been active at least once.",
          description:
            "Customers who had an active campaign in the selected month.",
        },
        {
          id: "total_client_standby",
          detail: "paused_clients",
          label: "Paused clients",
          data: [],
          textoToTooltip:
            "Total number of customers who stopped all their campaigns.",
          description:
            "Customers who went from active to standby status in the selected month.",
        },
        {
          id: "total_client_decliened_or_recovery",
          detail: "recovery_clients",
          label: " Recovery clients",
          data: [],
          textoToTooltip:
            "Total number of customers who have gone into judicial recovery.",
          description:
            "Customers who switched to Recovery status in the selected month.",
        },
        {
          id: "total_client_deleted",
          detail: "deleted_clients",
          label: "Deleted clients",
          data: [],
          textoToTooltip:
            "Total number of customers whose accounts have been deleted from Oliverlist.",
          description:
            "Customers who switched to Deleted status in the selected month.",
        },
        {
          id: "total_assigned_client",
          detail: "assigned_clients",
          label: "Assigned clients",
          data: [],
          textoToTooltip:
            "Total number of credit to client.",
          description:
            "Total number of credit to client.",
        },
      ],
      clients_avg: [
        {
          id: "total_client_churn",
          detail: "client_churn",
          label: "Client Churn - 1 month %",
          data: [],
          textoToTooltip:
            "The percentage of clients who stopped their subscription during their first month",
          description:
            "The percentage of clients who stopped their subscription during their first month",
        },
        {
          id: "total_client_churn_last_4_month",
          detail: "client_churn_last_4_month",
          label: "Client Churn - 4 month %",
          data: [],
          textoToTooltip:
            "The percentage of clients who stopped before their 4th month of collaboration.",
          description:
            "The percentage of clients who stopped before their 4th month of collaboration.",
        },
        {
          id: "total_avg_np",
          detail: "avg_np",
          label: "AVG NP w/ campaign time",
          data: [],
          textoToTooltip:
            "Average duration (in days) for email addresses not linked to a campaign to remain in 'Not Prospecting' status.",
          description:
            "Average duration (in days) for email addresses not linked to a campaign to remain in 'Not Prospecting' status.",
        },
        {
          id: "total_avg_time",
          detail: "avg_tim",
          label: "Average Time to Launch",
          data: [],
          textoToTooltip:
            "The average number of days between the 'Signature' and the 'First License Invoice' for clients signed during the Selected Period",
          description:
            "The average number of days between the 'Signature' and the 'First License Invoice' for clients signed during the Selected Period",
        },
        {
          id: "total_avg_margin",
          detail: "avg_margin",
          label: "Average Margin",
          data: [],
          textoToTooltip:
            "Average margin per billed client (Total Margin / Number of billed clients).",
          description:
            "Average margin per billed client with total income greater than 0.",
        },
        {
          id: "total_avg_revenue_client",
          detail: "avg_revenue_client",
          label: "Average revenue / client",
          data: [],
          textoToTooltip:
            "Average revenue per billed client (Paid invoices / Number of billed clients).",
          description:
            "Paid invoices divided by the number of clients billed at least once during the selected month.",
        },
      ],
      meeting: [
        {
          id: "email_sent",
          label: "Email sent",
          data: [],
          textoToTooltip:
            "Total number of emails sent.",
        },
        {
          id: "manual_answer_rate",
          label: "Manual Answer Rate",
          data: [],
          textoToTooltip:
            "Percentage of manual replies received from sent emails.",
        },
        {
          id: "meeting_contact_mail",
          label: "Meeting /   sent (mail)",
          data: [],
          textoToTooltip:
            "Percentage of contacts obtained from emails.",
        },
        {
          id: "meeting_booked_total",
          label: "Meeting booked (Total)",
          data: [],
          textoToTooltip:
            "Total number of meetings booked total.",
        },
      ],

      calls: [
        {
          id: "cold_call_dialed",
          label: "Cold call dialed",
          data: [],
          textoToTooltip:
            "Total number of cold calls dialed.",
        },
        {
          id: "cold_call_pickup_rate",
          label: "Cold Call Pick-up Rate",
          data: [],
          textoToTooltip:
            "Percentage of cold calls answered.",
        },
        {
          id: "meeting_contact_call",
          label: "Meeting / contact (call)",
          data: [],
          textoToTooltip:
            "Percentage of contacts obtained from cold calls.",
        },
        {
          id: "meeting_booked_cold_call",
          label: "Meeting booked (cold-call)",
          data: [],
          textoToTooltip:
            "Total number of meetings booked from cold calls.",
        },
      ],
      paramloading: {
        width: "58px",
        height: "58px",
        color: "#5054EB",
      },
      oliverSalesLoaded: false,
      oliverExecutiveLoaded: false,
      savingOliverUser: false,
      userOliverSale: ["0"],
      userOliverSales: [{ id: "0", label: "All" }],
      userOliverExecutive : ["0"],
      userAccountExecutives: [{ id: "0", label: "All" }],
      monthSelected: ["0"],
      currentMonth: moment().month() + 1,
      months: [
        { id: "0", label: "Select option..." },
        { id: "01", label: "January" },
        { id: "02", label: "February" },
        { id: "03", label: "March" },
        { id: "04", label: "April" },
        { id: "05", label: "May" },
        { id: "06", label: "June" },
        { id: "07", label: "July" },
        { id: "08", label: "August" },
        { id: "09", label: "September" },
        { id: "10", label: "October" },
        { id: "11", label: "November" },
        { id: "12", label: "December" },
      ],
      monthsWithData: [],
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    allLoading() {
      if(this.gettingDataSale || this.gettingDataProblem || this.gettingDataPerformance || this.gettingDataClient || this.gettingDataMeeting || this.gettingDataCalls || this.gettingDataClientAvg || this.gettingDataAverageMargin || this.gettingDataAverageRevenue) {
        return false;
      }
      return true;
    },
    isUserOliverSale() {
      return this.user.role_id == 1 && this.user.user_constraint_id == 2;
    },
    logoRevenueRanking() {
      return (total) => {
        const image = this.revenue_ranking.find(
          (el) => Number(total) >= el.min && Number(total) <= el.max
        ).img;
        return require(`@/assets/images/revene_ranking/mini/${image}`);
      };
    },
    compareTotals() {
      return (client, arrow = null) => {
        if (client.data && client.data.length > 0) {
          let currentTotal = null;
          let oldTotal = null;

          if (client.data.find((el) => el.current_month == "1")) {
            currentTotal =
              client.data.find((el) => el.current_month == "1").total || 0;
          }

          if (client.data.find((el) => el.current_month == "0")) {
            oldTotal =
              client.data.find((el) => el.current_month == "0").total || 0;
          }

          if (currentTotal == null || oldTotal == null) return "";

          if (arrow == "arrow") {
            if (Number(currentTotal) > Number(oldTotal))
              return "fas fa-arrow-up";
            if (Number(currentTotal) < Number(oldTotal))
              return "fas fa-arrow-down";
            return "";
          } else {
            if (
              client.id == "avg_lom" ||
              client.id == "avg_wac" ||
              client.id == "avg_com" ||
              client.id == "avg_lcm" ||
              client.id == "total_client_standby" ||
              client.id == "total_client_decliened_or_recovery" ||
              client.id == "total_client_deleted"
            ) {
              if (Number(currentTotal) > Number(oldTotal)) return "text-danger";
              if (Number(currentTotal) < Number(oldTotal))
                return "text-success";
            } else {
              if (Number(currentTotal) > Number(oldTotal))
                return "text-success";
              if (Number(currentTotal) < Number(oldTotal)) return "text-danger";
            }

            return "";
          }
        }
      };
    },
    getDate() {
      return (type, client) => {
        if (client.data && client.data.length > 0) {
          if (type == "currentMonth") {
            if (client.data.find((el) => el.current_month == "1")) {
              const statsDate = client.data.find(
                (el) => el.current_month == "1"
              ).stats_date;
              return moment(statsDate).format("MMM YY") + " :";
            }
          } else {
            if (client.data.find((el) => el.current_month == "0")) {
              const statsDate = client.data.find(
                (el) => el.current_month == "0"
              ).stats_date;
              return moment(statsDate).format("MMM YY") + " :";
            }
          }
        }
      };
    },
    getTotal() {
      return (type, client) => {
        if (client.data && client.data.length > 0) {
          const valuesWithDecimal = [
            "revenue_orders",
            "meetings_orders",
            "conversion_rate",
            "total_client_churn",
            "total_client_churn_last_4_month",
            "manual_answer_rate",
            "cold_call_pickup_rate",
            "meeting_contact_call",
            "meeting_contact_mail",
            "total_avg_margin",
            "total_avg_revenue_client",
          ];
          const valuesWithSimbolEuro = [
            "revenue_orders",
            "revenue",
            "revenue_subscriptions",
            "paid_leads",
            "avg_meeting_price",
            "declined_recovery_paid",
            "total_avg_margin",
            "total_avg_revenue_client",
          ];
          const valuesWithSimbolPercentage = [
            "conversion_rate",
            "meeting_contact_mail",
            "total_client_churn",
            "total_client_churn_last_4_month"]

          if (type == "currentMonth") {
            if (client.data.find((el) => el.current_month == "1")) {
              const value = client.data.find(
                (el) => el.current_month == "1"
              ).total;
              if (valuesWithDecimal.includes(client.id)) {
                if (valuesWithSimbolEuro.includes(client.id)) {
                  return valuesWithSimbolEuro.includes(client.id)
                    ? Number(value).toFixed(2) + " €"
                    : Number(value).toFixed(2);
                }

                if (valuesWithSimbolPercentage.includes(client.id)) {
                  return valuesWithSimbolPercentage.includes(client.id)
                    ? Number(value).toFixed(2) + " %"
                    : Number(value).toFixed(2);
                }
                return Number(value).toFixed(2);
              } else {
                if (valuesWithSimbolEuro.includes(client.id)) {
                  return valuesWithSimbolEuro.includes(client.id)
                    ? Number(value).toFixed(0) + " €"
                    : Number(value).toFixed(2);
                }

                if (valuesWithSimbolPercentage.includes(client.id)) {
                  return valuesWithSimbolPercentage.includes(client.id)
                    ? Number(value).toFixed(0) + " %"
                    : Number(value).toFixed(2);
                }
                return Number(value).toFixed(0);
              }
            }
          } else {
            //Si el valor que quiero mostrar es el total de mes anterior al mes seleccionado.
            if (client.data.find((el) => el.current_month == "0")) {
              const value = client.data.find(
                (el) => el.current_month == "0"
              ).total;
              if (value || value === 0 || client.id === "total_avg_margin" || client.id === "total_avg_revenue_client") {
                if (valuesWithDecimal.includes(client.id)) {
                  if (valuesWithSimbolEuro.includes(client.id)) {
                    return valuesWithSimbolEuro.includes(client.id)
                      ? Number(value).toFixed(2) + " €"
                      : Number(value).toFixed(2);
                  }

                  if (valuesWithSimbolPercentage.includes(client.id)) {
                    return valuesWithSimbolPercentage.includes(client.id)
                      ? Number(value).toFixed(2) + " %"
                      : Number(value).toFixed(2);
                  }

                  return Number(value).toFixed(2);
                } else {
                  if (valuesWithSimbolEuro.includes(client.id)) {
                    return valuesWithSimbolEuro.includes(client.id)
                      ? Number(value).toFixed(0) + " €"
                      : Number(value).toFixed(2);
                  }

                  if (valuesWithSimbolPercentage.includes(client.id)) {
                    return valuesWithSimbolPercentage.includes(client.id)
                      ? Number(value).toFixed(0) + " %"
                      : Number(value).toFixed(2);
                  }
                  return Number(value).toFixed(0);
                }
              }
            }
          }
        }
      };
    },
  },

  methods: {
    initData() {
      this.userOliverSale[0] = 0;
      this.userOliverExecutive[0] = 0;
      this.clients.forEach((el) => {
        el.data = [];
      });
      this.performances.forEach((el) => {
        el.data = [];
      });
      // this.problems.forEach((el) => {
      //   el.data = [];
      // });
      this.sales.forEach((el) => {
        el.data = [];
      });

      this.meeting.forEach((el) => {
        el.data = [];
      });

      this.calls.forEach((el) => {
        el.data = [];
      });

      this.clients_avg.forEach((el) => {
        el.data = [];
      });
    },
    OpenModal(item, label, description = null) {
      const itemAvailable = [
        "active_clients",
        "paused_clients",
        "recovery_clients",
        "deleted_clients",
        "new_clients",
        "new_orders",
        "new_orders_old_client",
        "declined_recovery_paid",
      ];
      if (itemAvailable.includes(item)) {
        this.itemDetail = item;
        this.itemLabel = label;
        this.itemDescription = description;
        this.$nextTick(() => {
          this.$modal.show("list");
        });
      }
    },
    selectOliverSale(value) {
      this.initData();
      if (value.id != 0) {
        if (this.filterYearMonth) {
          this.loadingDataSale = true;
          this.userOliverSale = [value.id];
          this.getData();
          this.getDataAboutThisSale(value.id);
        }
      }
    },
    selectOliverExecutive(value) {
      this.initData();
      if (value.id != 0) {
        if (this.filterYearMonth) {
          this.loadingDataExecutive = true;
          this.userOliverExecutive = [value.id];
          this.getData();
          this.getDataAboutThisSale(value.id);
        }
      }
    },
    getDataAboutThisSale(oliser_sale_id) {
      usersService.getOliveSaleAllRevenue(oliser_sale_id).then((res) => {
        if (res.result) {
          this.saleRankingData = res.result;
        }
        this.loadingDataSale = false;
      });
    },
    selectMonth(value) {
      this.initData();
      if (value.id != 0) {
        if (value !== this.previousValue) {
          this.monthSelected[0] = value;
          this.previousValue = value;
          (this.userOliverSale = ["0"]), (this.loadingDataSale = true);
          this.getUserOliverSales(null, this.filterYearMonth);
          this.getUserAccountExecutive();
        }
      }
    },
    getData() {

      let user_type = this.typeSelected == '2' ? "sale_oliver" : "account_executive";
      let user_id = this.typeSelected == '2' ? this.userOliverSale[0] : this.userOliverExecutive[0];

      //Meetings
        this.gettingDataMeeting = true;
      usersService
        .getOliverSalesDashboard(
          "meetings",
          this.filterYearMonth,
          user_type,
          user_id
        )
        .then((res) => {
          if (res.result) {
            const data = res.result;
            this.meeting[0].data = data.filter(
              (el) => el.label == "email_sent"
            );
            this.meeting[1].data = data.filter(
              (el) => el.label == "manual_answer_rate"
            );
            this.meeting[2].data = data.filter(
              (el) => el.label == "meeting_contact_mail"
            );
            this.meeting[3].data = data.filter(
              (el) => el.label == "meeting_booked_total"
            );
          }
          this.gettingDataMeeting = false;
        })
        .catch((err) => console.error(err));

      //Calls
      this.gettingDataCalls = true;
      usersService
        .getOliverSalesDashboard(
          "calls",
          this.filterYearMonth,
          user_type,
          user_id
        )
        .then((res) => {
          if (res.result) {
            const data = res.result;

            this.calls[0].data = data.filter(
              (el) => el.label == "cold_call_dialed"
            );
            this.calls[1].data = data.filter(
              (el) => el.label == "cold_call_pickup_rate"
            );
            this.calls[2].data = data.filter(
              (el) => el.label == "meeting_contact_call"
            );
            this.calls[3].data = data.filter(
              (el) => el.label == "meeting_booked_cold_call"
            );
          }
          this.gettingDataCalls = false;
        })
        .catch((err) => console.error(err));


      //Clients
      this.gettingDataClient = true;
      usersService
        .getOliverSalesDashboard(
          "clients",
          this.filterYearMonth,
          user_type,
          user_id
        )
        .then((res) => {
          if (res.result) {
            const data = res.result;

            this.clients[0].data = data.filter(
              (el) => el.label == "total_client_active"
            );
            this.clients[1].data = data.filter(
              (el) => el.label == "total_client_standby"
            );
            this.clients[2].data = data.filter(
              (el) => el.label == "total_client_decliened_or_recovery"
            );
            this.clients[3].data = data.filter(
              (el) => el.label == "total_client_deleted"
            );
            this.clients[4].data = data.filter(
              (el) => el.label == "total_assigned_client"
            );
          }
          this.gettingDataClient = false;
        })
        .catch((err) => console.error(err));


      //Clients AVG
      this.gettingDataClientAvg = true;
      usersService
        .getOliverSalesDashboard(
          "client_details",
          this.filterYearMonth,
          user_type,
          user_id
        )
        .then((res) => {
          if (res.result) {
            const data = res.result;

            this.clients_avg[0].data = data.filter(
              (el) => el.label == "total_client_churn"
            );
            this.clients_avg[1].data = data.filter(
              (el) => el.label == "total_client_churn_last_4_month"
            );
            this.clients_avg[2].data = data.filter(
              (el) => el.label == "total_avg_np"
            );
            this.clients_avg[3].data = data.filter(
              (el) => el.label == "total_avg_time"
            );
          }
          this.gettingDataClientAvg = false;
        })
        .catch((err) => {
          console.error(err);
          this.gettingDataClientAvg = false;
        });

      this.loadSalesAndPaymentMetrics(user_id, user_type);

      //Performances
      this.gettingDataPerformance = true;
      usersService
        .getOliverSalesDashboard(
          "performances",
          this.filterYearMonth,
          user_type,
          user_id
        )
        .then((res) => {
          if (res.result) {
            const data = res.result;

            this.performances[0].data = data.filter(
              (el) => el.label == "revenue"
            );
            this.performances[1].data = data.filter(
              (el) => el.label == "revenue_subscriptions"
            );
            this.performances[2].data = data.filter(
              (el) => el.label == "revenue_orders"
            );
            this.performances[3].data = data.filter(
              (el) => el.label == "meetings_orders"
            );
            this.performances[4].data = data.filter(
              (el) => el.label == "conversion_rate"
            );
          }
          this.gettingDataPerformance = false;
        })
        .catch((err) => console.error(err));

      // Problem resolving
      // this.gettingDataProblem = true;
      // usersService
      //   .getOliverSalesDashboard(
      //     "problems",
      //     this.filterYearMonth,
      //     user_type,
      //     user_id
      //   )
      //   .then((res) => {
      //     if (res.result) {
      //       const data = res.result;

      //       if (data.length > 0) {
      //         this.problems[0].data = data.filter(
      //           (el) => el.label == "avg_lcm"
      //         );
      //         this.problems[1].data = data.filter(
      //           (el) => el.label == "avg_lom"
      //         );
      //         this.problems[2].data = data.filter(
      //           (el) => el.label == "avg_com"
      //         );
      //         this.problems[3].data = data.filter(
      //           (el) => el.label == "avg_wac"
      //         );
      //       }
      //     }
      //     this.gettingDataProblem = false;
      //   })
      //   .catch((err) => console.error(err));
    },
    isAlwaysVisibleClientAvgMetric(client) {
      return (
        client.id === "total_avg_margin" ||
        client.id === "total_avg_revenue_client"
      );
    },
    isClientAvgMetricLoading(client) {
      if (client.id === "total_avg_margin") {
        return this.gettingDataAverageMargin;
      }
      if (client.id === "total_avg_revenue_client") {
        return this.gettingDataAverageRevenue;
      }
      return this.gettingDataClientAvg;
    },
    getClientAvgIndex(metricId) {
      return this.clients_avg.findIndex(function (client) {
        return client.id === metricId;
      });
    },
    loadSalesAndPaymentMetrics(user_id, user_type) {
      const avgMarginIndex = this.getClientAvgIndex("total_avg_margin");
      const avgRevenueIndex = this.getClientAvgIndex("total_avg_revenue_client");
      if (avgMarginIndex === -1 || avgRevenueIndex === -1) {
        return;
      }

      this.gettingDataSale = true;
      this.gettingDataAverageMargin = true;
      this.gettingDataAverageRevenue = true;

      const previousMonth = moment(this.filterYearMonth, "YYYY-MM")
        .subtract(1, "month")
        .format("YYYY-MM");
      const clientMarginParams = {
        yearMonth: this.filterYearMonth,
        client_status_id: 0,
        account_manager: user_id === "all" ? 0 : user_id,
        subscription_status: 0,
      };
      const clientMarginParamsPrev = Object.assign({}, clientMarginParams, {
        yearMonth: previousMonth,
      });

      Promise.all([
        usersService.getOliverSalesDashboard(
          "sales",
          this.filterYearMonth,
          user_type,
          user_id
        ),
        clientsService.getReportPaymentClient(clientMarginParams),
        clientsService.getReportPaymentClient(clientMarginParamsPrev),
      ])
        .then(function (results) {
          const salesRes = results[0];
          const currentRows = this.getReportPaymentRows(results[1]);
          const prevRows = this.getReportPaymentRows(results[2]);
          let paidLeadsData = [];

          if (salesRes.result) {
            const data = salesRes.result;

            this.sales[0].data = data.filter((el) => el.label == "new_clients");
            paidLeadsData = data.filter((el) => el.label == "paid_leads");
            this.sales[1].data = paidLeadsData;
            this.sales[2].data = data.filter((el) => el.label == "new_orders");
            this.sales[3].data = data.filter((el) => el.label == "total_orders");
            this.sales[4].data = data.filter(
              (el) => el.label == "avg_meeting_price"
            );
            this.sales[5].data = data.filter(
              (el) => el.label == "declined_recovery_paid"
            );
          }

          this.$set(
            this.clients_avg[avgMarginIndex],
            "data",
            this.buildAverageMarginData(
              currentRows,
              prevRows,
              this.filterYearMonth,
              previousMonth
            )
          );
          this.$set(
            this.clients_avg[avgRevenueIndex],
            "data",
            this.buildAverageRevenueClientData(
              paidLeadsData,
              currentRows,
              prevRows,
              this.filterYearMonth,
              previousMonth
            )
          );

          this.gettingDataSale = false;
          this.gettingDataAverageMargin = false;
          this.gettingDataAverageRevenue = false;
        }.bind(this))
        .catch(function (err) {
          console.error(err);
          this.$set(
            this.clients_avg[avgMarginIndex],
            "data",
            this.buildAverageMarginData(
              [],
              [],
              this.filterYearMonth,
              previousMonth
            )
          );
          this.$set(
            this.clients_avg[avgRevenueIndex],
            "data",
            this.buildAverageRevenueClientData(
              [],
              [],
              [],
              this.filterYearMonth,
              previousMonth
            )
          );
          this.gettingDataSale = false;
          this.gettingDataAverageMargin = false;
          this.gettingDataAverageRevenue = false;
        }.bind(this));
    },
    getPaidInvoicesTotal(paidLeadsData, currentMonthFlag) {
      if (!paidLeadsData || !paidLeadsData.length) {
        return 0;
      }

      const entry = paidLeadsData.find(function (item) {
        return item.current_month == currentMonthFlag;
      });

      return entry ? parseFloat(entry.total) || 0 : 0;
    },
    getReportPaymentRows(data) {
      return Array.isArray(data) ? data : (data && data.result) || [];
    },
    countBilledClients(rows) {
      let billedClients = 0;

      rows.forEach(function (item) {
        const totalIncome = parseFloat(item.total_income) || 0;
        if (totalIncome > 0) {
          billedClients += 1;
        }
      });

      return billedClients;
    },
    calculateAverageMargin(rows) {
      let totalMargin = 0;

      rows.forEach(function (item) {
        const totalIncome = parseFloat(item.total_income) || 0;
        if (totalIncome > 0) {
          totalMargin += parseFloat(item.margin) || 0;
        }
      });

      const billedClients = this.countBilledClients(rows);
      return billedClients > 0 ? totalMargin / billedClients : 0;
    },
    calculateAverageRevenueClient(paidInvoices, rows) {
      const billedClients = this.countBilledClients(rows);
      return billedClients > 0 ? paidInvoices / billedClients : 0;
    },
    buildAverageMarginData(currentRows, prevRows, currentMonth, previousMonth) {
      return [
        {
          label: "total_avg_margin",
          current_month: "1",
          total: this.calculateAverageMargin(currentRows),
          stats_date: moment(currentMonth, "YYYY-MM").endOf("month").format("YYYY-MM-DD"),
        },
        {
          label: "total_avg_margin",
          current_month: "0",
          total: this.calculateAverageMargin(prevRows),
          stats_date: moment(previousMonth, "YYYY-MM").endOf("month").format("YYYY-MM-DD"),
        },
      ];
    },
    buildAverageRevenueClientData(
      paidLeadsData,
      currentRows,
      prevRows,
      currentMonth,
      previousMonth
    ) {
      return [
        {
          label: "total_avg_revenue_client",
          current_month: "1",
          total: this.calculateAverageRevenueClient(
            this.getPaidInvoicesTotal(paidLeadsData, "1"),
            currentRows
          ),
          stats_date: moment(currentMonth, "YYYY-MM").endOf("month").format("YYYY-MM-DD"),
        },
        {
          label: "total_avg_revenue_client",
          current_month: "0",
          total: this.calculateAverageRevenueClient(
            this.getPaidInvoicesTotal(paidLeadsData, "0"),
            prevRows
          ),
          stats_date: moment(previousMonth, "YYYY-MM").endOf("month").format("YYYY-MM-DD"),
        },
      ];
    },
    getUserAccountExecutive(){
      this.oliverExecutiveLoaded = true;
      usersService.getUserOliverExecutives().then((res) => {
        if(res.result.length > 0) {
          this.userAccountExecutives = [
            { id: "0", label: "Select option..." },
            { id: "all", label: "All" },
          ];
          const userAccountExecutivesWithlabel = res.result.map((el) => ({
            ...el,
            label: el.lastname + ", " + el.name,
          }));
          this.userAccountExecutives.push(...userAccountExecutivesWithlabel);
        }
        this.oliverExecutiveLoaded = false;
      })
    },
    getUserOliverSales(complete, month) {
      this.oliverSalesLoaded = true;
      usersService
        .getUserOliverSales(true, month, true)
        .then((res) => {
          if (res.result.length > 0) {
            this.userOliverSales = [
              { id: "0", label: "Select option..." },
              { id: "all", label: "All" },
            ];
            const userOliverSalesWithlabel = res.result.map((el) => ({
              ...el,
              label: el.lastname + ", " + el.name,
            }));
            this.userOliverSales.push(...userOliverSalesWithlabel);
            this.oliverSalesLoaded = false;

            if (this.isUserOliverSale) {
              const findUserOliverSale = this.userOliverSales.find(
                (el) => el.id == this.user.id
              );
              if (findUserOliverSale) {
                this.userOliverSale = [findUserOliverSale.id];
                this.getData();
              }
            }
          }
        })
        .catch((err) => console.error(err));
    },
  },
};
</script>
